import {
  ArrowLeftIcon,
  ChatCircleIcon,
  EnvelopeIcon,
  FacebookLogoIcon,
  HeartIcon,
  InstagramLogoIcon,
  LinkedinLogoIcon,
  LinkSimpleIcon,
  MapPinIcon,
  PhoneIcon,
  ShareFatIcon,
  XLogoIcon,
  YoutubeLogoIcon,
} from "@phosphor-icons/react";
import { Skeleton } from "../Skeleton";

export const SkeletonStructureDetails = () => (
  <div className="relative w-full rounded-lg">
    <div className="absolute z-0 size-full" />
    <div className="relative z-10 w-full md:p-10">
      {/* Banner Skeleton */}
      <div className="w-full">
        <Skeleton className="aspect-[9/3] w-full object-cover md:aspect-[456/64] md:rounded-xl" />
      </div>

      <div className="flex w-full flex-col gap-4 px-10">
        {/* Mobile Back/Share Buttons */}
        <div className="-mt-4 flex w-full justify-between px-4 md:hidden">
          <button className="items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white p-2">
            <ArrowLeftIcon size={16} className="text-primary-500 size-5" />
          </button>
          <button className="items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white p-2">
            <ShareFatIcon className="text-primary-500 size-5" />
          </button>
        </div>

        {/* Structure Name Section */}
        <div className="w-full mt-2 md:-mt-4">
          <div className="flex h-full flex-col gap-4">
            <div className="flex flex-col gap-2 md:flex-row">
              <div className="flex w-full gap-2">
                {/* Avatar Skeleton */}
                <div className="flex justify-center rounded-full bg-blue-50">
                  <Skeleton className="size-[64px] md:size-[96px] rounded-full" />
                </div>

                {/* Business Name & Sector */}
                <div className="flex flex-1 flex-col justify-end gap-1">
                  <Skeleton className="h-9 w-48" />
                  <Skeleton className="h-7 w-32" />
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex items-end gap-2">
                <button className="flex grow items-center justify-center gap-2 rounded-lg bg-blue-500 px-4 py-2 text-base text-white">
                  <ChatCircleIcon width={24} height={24} fill="white" />
                  Contacter
                </button>

                <button className="border-primary-400 bg-primary-25 hidden items-center justify-center gap-2 rounded-lg border p-2 md:flex">
                  <ShareFatIcon className="text-primary-400 size-6" />
                </button>

                <button className="hidden grow items-center justify-center gap-2 rounded-lg border border-amber-700 bg-amber-50 p-2 text-amber-700 md:flex">
                  <HeartIcon className="size-6" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Description Skeleton */}
        <div className="text-lg text-gray-900 font-normal w-2/3">
          <Skeleton className="h-6 w-full" />
          <Skeleton className="h-6 w-4/5 mt-2" />
        </div>

        {/* Contact Section */}
        <div className="flex">
          {/* Links Section */}
          <div className="grid flex-1 gap-2 overflow-hidden md:grid-cols-2">
            <div className="flex items-center gap-1">
              <MapPinIcon size={20} className="text-secondary-500" />
              <Skeleton className="h-5 w-40" />
            </div>
            <div className="flex items-center gap-1">
              <EnvelopeIcon size={20} className="text-secondary-500" />
              <Skeleton className="h-5 w-36" />
            </div>
            <div className="flex items-center gap-1">
              <PhoneIcon size={20} className="text-secondary-500" />
              <Skeleton className="h-5 w-32" />
            </div>
            <div className="flex items-center gap-1">
              <LinkSimpleIcon size={20} className="text-secondary-500" />
              <Skeleton className="h-5 w-44" />
            </div>
          </div>

          {/* Socials Section */}
          <div className="flex w-full grid-cols-3 justify-center gap-4 md:grid md:w-auto md:items-start">
            <a href="./">
              <FacebookLogoIcon size={24} fill="#1B6298" />
            </a>
            <a href="./">
              <XLogoIcon size={24} fill="#1B6298" />
            </a>
            <a href="./">
              <InstagramLogoIcon size={24} fill="#1B6298" />
            </a>
            <a href="./">
              <YoutubeLogoIcon size={24} fill="#1B6298" />
            </a>
            <a href="./">
              <LinkedinLogoIcon size={24} fill="#1B6298" />
            </a>
          </div>
        </div>

        {/* Tabs Section */}
        <div>
          <div className="flex w-full justify-start rounded-none border-0 bg-transparent px-6">
            <div className="flex grow cursor-pointer flex-col items-center border-b-2 border-blue-500 px-2 py-1">
              <MapPinIcon
                height={24}
                width={24}
                fill="#287BB9"
                aria-hidden="true"
              />
              <p className="text-center text-blue-500">Participations</p>
            </div>
          </div>

          {/* Tab Content - Participations Panel */}
          <div className="border border-gray-200 bg-gray-50 rounded-3xl">
            <div className="size-full gap-6 overflow-y-auto p-6">
              <div className="h-full overflow-y-auto px-1 xl:px-0">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                  {[...Array(6)].map((_, index) => (
                    <div
                      key={index}
                      className="flex flex-col gap-2 rounded-lg border border-gray-200 p-4"
                    >
                      <Skeleton className="aspect-video w-full rounded-lg" />
                      <Skeleton className="h-6 w-3/4" />
                      <Skeleton className="h-4 w-1/2" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
